import { NewVehicleFieldsModel } from './typings/new-vehicle-fields';

// a vehicle is only added once it can be named: a colour alone would leave lists with nothing to show
export function hasNewVehicleName ( vehicle : NewVehicleFieldsModel ) : boolean {
  return !!vehicle
    && [ vehicle.plate_number, vehicle.make, vehicle.model ].some(part => !!( part || '' ).trim());
}
